import { Component, EventEmitter, Output} from '@angular/core';
import { VisitEventType, VisitFilterType } from '../model/model.class';
import { SharedService } from '../shared.service';

export interface VisitSelectionEvent {
  allOptions: VisitEventType[];
  lastChanged: VisitEventType;
}

@Component({
  selector: 'visit-filter-popup',
  templateUrl: './visit-filter-popup.component.html'
})
export class VisitFilterPopupComponent {

  @Output() selectionChange = new EventEmitter<VisitSelectionEvent>();

  options: VisitEventType[];

  constructor(private sharedService: SharedService) {

    this.options = this.sharedService.getVisitFilterOptions().filter(i => i.visible);
  }

  selectOption(changedOption: VisitEventType) {
    const index = this.options.findIndex(o => o.key === changedOption.key);
    if (index > -1) {
      this.options[index] = changedOption;
    }

    this.sharedService.setVisitFilterOptions(this.options);

    const selectedCount = this.options.filter(o => o.selected).length;
    this.sharedService.setViewText(
      selectedCount === this.options.length ? 'All' : `${selectedCount}`
    );

    const event: VisitSelectionEvent = {
      allOptions: this.options,
      lastChanged: changedOption
    };
    this.selectionChange.emit(event);
  }
}



// WEBPACK FOOTER //
// ./src/app/visit-filter-popup/visit-filter-popup.component.ts